var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "address_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".address_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5V15c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5V9.5",
    className: "address_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 11 5.1-5.1c.2-.2.5-.2.7 0l5.1 5.1M11 15.5v-3c0-.6.4-1 1-1s1 .4 1 1v3",
    className: "address_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.7c.1 0 .2.1.2.2M11.8 9c0-.1.1-.2.2-.2M12 9.2c-.1 0-.2-.1-.2-.2M12.2 9c0 .1-.1.2-.2.2",
    className: "address_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5c2.2 0 4.3.6 6.1 1.8 4.8 3 5.1 9.2 1.3 13.8-2.2 2.7-4.7 5.2-7.4 7.5-2.7-2.3-5.2-4.7-7.4-7.5C.8 11.5 1.1 5.3 5.9 2.3 7.7 1.1 9.8.5 12 .5",
    className: "address_svg__st0"
  })));
};
export default SvgAddress;